import script from "./RequestAccessDatasetModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestAccessDatasetModal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__